import { Component } from '@theme/component';

class MarqueeComponent extends Component {
  requiredRefs = ['wrapper', 'content', 'marqueeItems'];

  connectedCallback() {
    super.connectedCallback();
    const { wrapper, content, marqueeItems } = this.refs;
    if (!marqueeItems.length) return;

    // Forza layer GPU per evitare repaint bianco
    wrapper.style.willChange = 'transform';
    wrapper.style.backfaceVisibility = 'hidden';
    wrapper.style.transform = 'translateZ(0)';

    // Clona tutto il content una sola volta per loop infinito
    const clone = content.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(clone);

    // Decode immagini prima dell'animazione
    wrapper.querySelectorAll('img').forEach(img => img.decode?.());

    // Durata fissa per velocità veloce
    const duration = 12000; // 12 secondi, aumenta o diminuisci per cambiare velocità

    // Inizializza animazione
    this.#marqueeAnimation = wrapper.animate(
      [
        { transform: 'translateX(0)' },
        { transform: `translateX(-${content.scrollWidth}px)` }
      ],
      { duration, iterations: Infinity, easing: 'linear' }
    );

    // Hover slowdown
    this.addEventListener('pointerenter', () => this.#marqueeAnimation.updatePlaybackRate(0.2));
    this.addEventListener('pointerleave', () => this.#marqueeAnimation.updatePlaybackRate(1));

    // Aggiorna animazione al resize
    window.addEventListener('resize', this.#handleResize);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#marqueeAnimation?.cancel();
    window.removeEventListener('resize', this.#handleResize);
  }

  #marqueeAnimation = null;

  #handleResize = () => {
    const { wrapper, content } = this.refs;
    if (!this.#marqueeAnimation) return;

    const duration = 12000; // stessa durata fissa

    // Riavvia animazione con nuova larghezza
    this.#marqueeAnimation.cancel();
    this.#marqueeAnimation = wrapper.animate(
      [
        { transform: 'translateX(0)' },
        { transform: `translateX(-${content.scrollWidth}px)` }
      ],
      { duration, iterations: Infinity, easing: 'linear' }
    );
  };
}

if (!customElements.get('marquee-component')) {
  customElements.define('marquee-component', MarqueeComponent);
}